import contentHash from './content-hash';

let cache = {};

export const clearMemCache = () => {
  cache = {};
};

export const memo = (callback, dependencies = []) => (...args) => {
  const hash = contentHash(JSON.stringify(dependencies.concat(args)));
  const cached = cache[hash];
  if (cached != null) {
    return cached;
  }
  const result = callback(...args);
  cache[hash] = result;
  return result;
};

export default {
  memo,
  clearMemCache,
};



// WEBPACK FOOTER //
// ./static/js/v0/utilities/memo.js